import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, styled } from "@mui/material";
import { CircularProgress } from "../CircularProgress";
import { convertPxToRem } from "../../util-functions";
const loadingTextOptions = [
    "Grind, fill, roll, seal, light, puff, pass, repeat...",
    "What did the doctor say to the weed plant?<br /> Your vitals are pretty high.",
    "What do you call a business started by<br /> cannabis enthusiasts? A joint venture!",
    "You can't spell healthcare without THC.",
    "Friendly reminder to stay high-drated!",
    "I don't always roll a joint, but when I do, <br />it's my ankle.",
    "Just keep rollin', just keep rollin'",
    "If weed puns are a sin, I'll see you all inhale.",
    "You might not like my cultivation puns, <br />but that's grow biz!",
    "What did Obi Weed Kenobi say to Anakin?<br />I've got the high ground.",
    "I'm going to be blunt, you're amazing.",
    "Did you hear about the cows smoking weed and<br /> playing poker? The steaks were high.",
    "Oh wait... Have you got a lighter?",
    "Marijuana marinara? Now that's an idea...",
    "My turtle is an expert in smell and flavor. <br />He's a terrific terpene terrapin.",
];
const StyledPageLoaderWrapper = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    width: convertPxToRem(267),
}));
const StyledCircularLoaderWrapper = styled(Box)(() => ({
    marginBottom: convertPxToRem(32),
}));
export const PageLoader = ({ testId, disableShrink = false, }) => {
    const selectedText = loadingTextOptions[Math.floor(Math.random() * loadingTextOptions.length)];
    return (_jsxs(StyledPageLoaderWrapper, Object.assign({ "data-testid": testId }, { children: [_jsx(StyledCircularLoaderWrapper, { children: _jsx(CircularProgress, { disableShrink: disableShrink }) }), _jsx(Typography, Object.assign({ variant: "h6", color: "primaryBlack", marginBottom: convertPxToRem(16) }, { children: "Getting everything ready..." })), _jsx(Typography, { variant: "smallText", color: "textSecondary", dangerouslySetInnerHTML: {
                    __html: selectedText,
                } })] })));
};
